import { ReactElement, ReactNode } from "react";

import { MEDIA_QUERIES } from "context/media/MediaConstant";
import styled from "styled-components";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

interface StyledPanelProps {
  /**
   * Panel width value
   * @type {string}
   */
  width?: string;

  /**
   * Panel margin-top value
   * @type {string}
   */
  marginTop?: string;
  marginBottom?: string;
  paddingTop?: string;
  top?: string;
  padding?: string;
}
export interface PageHeaderProps {
  width?: string;
  title?: string;
  padding?: string;
  iconSrc?: string;
  backgroundColor?: string;
  rowEndButton?: () => ReactElement;
  children?: ReactNode;
}

export const StyledPanel = styled.div<StyledPanelProps>`
  position: relative;
  margin-bottom: ${({ marginBottom = "32px" }) => marginBottom};
  padding-bottom: 5px;

  background-color: ${({ theme }) => theme.colors.transparent};

  border-radius: 10px;

  width: ${({ width = "auto" }) => width};
  margin-top: ${({ marginTop = "auto" }) => marginTop};
  padding-top: ${({ paddingTop = "auto" }) => paddingTop};
  top: ${({ top = "auto" }) => top};

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: ${({ padding = "0 3px 5px" }) => padding};
    width: 100%;
    margin-bottom: 1px;
  }
`;

export const StyledPanelHeader = styled.div<PageHeaderProps>`
  width: ${({ width = "auto" }) => width};
  height: 45px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: ${({ padding = "0 5px 5px 20px" }) => padding};

  background-color: ${({
    backgroundColor = DIGIPOSTHEME.colors.secondaryAkbankWhite,
  }) => backgroundColor};

  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  @media ${MEDIA_QUERIES.MOBILE} {
    font-size: 16px;
    height: 45px;
  }
`;

export const PanelHeaderText = styled.div`
  display: flex;
  flex: 1;
  align-items: center;

  font-family: "Campton";
  letter-spacing: 0.23px;
  line-height: 20px;
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.secondaryAkbankBlack};

  @media ${MEDIA_QUERIES.MOBILE} {
    margin-top: 8px;
    min-width: 104px;
    font-size: 16px;
    padding: 5px;
  }
`;
